import { withBusyIndicator } from "@components/busyIndicator/withBusyIndicator";
import SelectionTableViewBase from "@components/smart/selectionTableView/SelectionTableViewBase";

class PickExtraSalaryTableView extends SelectionTableViewBase {
    _keepActiveRowsOnFilterChange = false;

    get secondaryTitle(): string {
        return this.props.storage.t("ExtraSalary:SelectionTableView.Title");
    }

    get selectionConfirmText(): string {
        return this.props.storage.t("ExtraSalary:SelectionTableView.Complete");
    }

    get successMessage(): string {
        return this.props.storage.t("ExtraSalary:SelectionTableView.Success");
    }
}

export default withBusyIndicator({ passBusyIndicator: true })(PickExtraSalaryTableView);
